module.exports = __webpack_public_path__ + "img/04.ac41d793.png";